import { useEffect, useState } from 'react'
import Spinner from '../Spinner'
import styles from './EvervizEmbed.module.css'
import { eventTracking } from '../../utils/Tracking'

interface ComponentProps {
  uid: string | undefined
  chartTitle: string | undefined
  isLayout?: boolean | undefined
  wrapperRef?: React.RefObject<HTMLElement>
  sectionTitle: string | undefined
  embedCharts: boolean
}

function EvervizEmbed({
  uid,
  isLayout,
  chartTitle,
  sectionTitle,
  embedCharts = true,
}: ComponentProps): JSX.Element {
  const [showLoader, setShowLoader] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const [uniqueId] = useState(`${Math.random()}`)

  useEffect(() => {
    setTimeout(() => {
      if (!loaded) {
        setShowLoader(true)
      }
    }, 1000)
  }, [loaded, setShowLoader])
  useEffect(() => {
    if (loaded) {
      setShowLoader(false)
    }
  }, [loaded])

  return (
    <div className={styles['everviz-embed']}>
      <div>
        {showLoader && (
          <div className={styles['everviz-embed-loading']}>
            <Spinner />
          </div>
        )}
        {embedCharts && (
          <iframe
            className={styles['everviz-embed-iframe']}
            loading='lazy'
            onMouseEnter={() => {
              eventTracking({
                event: 'bp-global-energy-outlook-interaction',
                eventAction: 'hover',
                eventCategory: sectionTitle,
                eventLabel: `${chartTitle} - hover in`,
                eventUrl: window.location.href,
              })
            }}
            onMouseLeave={() => {
              eventTracking({
                event: 'bp-global-energy-outlook-interaction',
                eventAction: 'hover',
                eventCategory: sectionTitle,
                eventLabel: `${chartTitle} - hover out`,
                eventUrl: window.location.href,
              })
            }}
            title={chartTitle}
            id={`iframe-${uniqueId}`}
            onLoad={() => {
              setLoaded(true)
              setShowLoader(false)
            }}
            src={`${
              process.env.PUBLIC_URL
            }/embedContainer/index.html?uid=${uid}&uniqueId=${uniqueId}&isLayout=${!!isLayout}`}
            scrolling='no'
          />
        )}
      </div>
    </div>
  )
}

export default EvervizEmbed
